import { useMutation } from "@apollo/client";
import { CircularProgress } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import photo from "assets/images/defaultimageuser.svg";
import Dialog from "components/Dialog";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import { Slogan } from "domains/Task/components/Slogan/Slogan";
import { UpdateCompanyUser, UserChangePassword } from "domains/Users/graphql/mutations";
import { CompanyUser } from "generated/graphql";
import { CURRENT_USER } from "hooks/useCurrentUser";
import { CameraIcon } from "icons";
import React from "react";
import styled from "styled-components";
import "styled-components/macro";
import { ChangePassword, Passwords } from "./ChangePassword";
import { UpdateProfil } from "./UpdateProfil";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      height: "100vh",
    },
    top: {
      flex: 1,
      backgroundColor: "#fff",
      borderRadius: 15,
      marginBottom: 20,
      display: "flex",
    },
    center: {
      flex: 4,
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      position: "relative",
      background: "#fff",
    },
    slogan: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-evenly",
      padding: 20,
      paddingLeft: 60,
      marginBottom: "auto",
      height: 200,
    },
    img: {
      marginLeft: "auto",
      marginRight: 20,
      marginTop: 20,
    },
    first_circle: {
      height: 190,
      width: 190,
      borderRadius: "100%",
      background: "#f8f8f8",
      display: "flex",
      justifyContent: "center",
      position: "absolute",
      top: -70,
      left: 60,
    },
    second_circle: {
      height: 170,
      width: 170,
      borderRadius: "100%",
      background: `url(${photo})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      margin: "auto",
      position: "relative",
    },
    camera: {
      position: "absolute",
      height: 30,
      width: 30,
      zIndex: 4,
      borderRadius: "100%",
      background: "#399ebf",
      display: "flex",
      justifyContent: "center",
      bottom: 20,
      right: -3,
    },
    icon: {
      margin: "auto",
      padding: "auto",
      cursor: "pointer",
      marginLeft: "auto",
      marginRight: "auto",
    },
    centered: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      marginTop: -100,
    },
    photo_circle: {
      backgroundSize: "cover",
      height: 170,
      width: 170,
      borderRadius: "100%",
      margin: "auto",
      position: "relative",
    },
  })
);

export const DivInfo = styled.div`
  width: 437px;
  height: 47px;
  border-radius: 8px;
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.25);
  background-color: #fff;
`;

export interface LeftSideProfileProps {
  user: CompanyUser;
  refetch: any;
}
export function UserProfile({ user, refetch }: LeftSideProfileProps) {
  const styles = useStyles();
  const dispatchAlert = useAlertDispatch();
  const [isUpdate, update] = React.useState(false);
  const [confirm, setConfirm] = React.useState(false);
  const [newProfil, setNewProfil] = React.useState<CompanyUser>(null);
  const [updateUserCompagny] = useMutation(UpdateCompanyUser);
  const [updatePassword] = useMutation(UserChangePassword);
  const [openUpdatePassword, setOpenUpdatePasseword] = React.useState<boolean>(false);
  const [isPwd, pwd] = React.useState(false);
  const [newPassword, setnewPassword] = React.useState<Passwords>(null);
  const ref = React.useRef(null);
  const [loadingImage, setLoadingImage] = React.useState<boolean>(false);
  const { text } = useText();
  const uploadUrl = process.env.REACT_APP_FILE_URL;

  const handlerUpdate = (value: CompanyUser) => {
    setNewProfil(value);
    setConfirm(true);
  };
  const resetPassword = () => {
    pwd(true);
    setOpenUpdatePasseword(true);
  };
  const handlePasswordChange = (pwd: Passwords) => {
    setnewPassword(pwd);
    setOpenUpdatePasseword(false);
    setConfirm(true);
  };
  const updateUserHandler = (url?: string) => {
    update(false);
    pwd(false);
    let input: any = {};
    if (url) {
      input.company_user_picture_url = url ?? user?.company_user_picture_url;
    } else {
      input = {
        company_user_firstname: newProfil?.company_user_firstname,
        company_user_lastname: newProfil?.company_user_lastname,
        company_user_job: newProfil?.company_user_job,
        company_user_profil: newProfil?.company_user_profil,
        company_user_phone_number: newProfil?.company_user_phone_number,
      };
    }
    updateUserCompagny({
      variables: {
        input: {
          companyUser: input,
          id: user?._id,
        },
      },
      refetchQueries: [{ query: CURRENT_USER }],
      awaitRefetchQueries: true,
    })
      .then((response) => {
        // todo
        const { message, code } = response.data.updateCompanyUser;
        if (code === 200) {
          dispatchAlert({ message: text.users.user_updated_msg, severity: "success" });
          refetch();
        } else {
          dispatchAlert({ message, severity: "warning" });
        }
        setLoadingImage(false);
      })
      .catch(() => {
        dispatchAlert({ message: text.users.user_not_updated_msg, severity: "error" });
        setLoadingImage(false);
      });
  };

  const changePassword = () => {
    updatePassword({
      variables: {
        input: {
          newPassword: newPassword.new_password,
          password: newPassword.old_password,
        },
      },
    })
      .then((response) => {
        // todo
        const { message, code } = response.data.clientChangePassword;
        dispatchAlert({
          message,
          severity: code === 200 ? "success" : "warning",
        });
      })
      .catch(() => {
        dispatchAlert({ message: "Sorry! try again later!", severity: "error" });
      });
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files[0]) {
      const { type } = files[0];
      if (type.indexOf("image") !== 0) {
        return dispatchAlert({
          message: "The imaage is not deleted",
          severity: "error",
        });
      }
      // call api
      setLoadingImage(true);
      const image = files[0];
      const formData = new FormData();
      formData.append("file", image, `${user?._id}_${image.name}`);
      fetch(uploadUrl, { method: "POST", body: formData }).then((response) => {
        if (response.ok) {
          response.text().then((textResponse) => {
            const url = JSON.parse(textResponse);
            updateUserHandler(url?.url);
          });
        }
      });
    }
  };
  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <Slogan showButton={false} />
      </div>
      <div className={styles.center}>
        <div className={styles.first_circle}>
          {loadingImage ? (
            <div
              style={{
                height: 170,
                width: 170,
                borderRadius: "100%",
                margin: "auto",
                position: "relative",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  marginTop: "40%",
                }}
              >
                <CircularProgress />
              </div>
            </div>
          ) : (
            <div
              style={{
                height: 170,
                width: 170,
                borderRadius: "100%",
                margin: "auto",
                position: "relative",
              }}
            >
              <img
                src={user?.company_user_picture_url ?? photo}
                style={{
                  height: "100%",
                  width: "100%",
                  borderRadius: "100%",
                }}
                alt={`the default ${photo}`}
              />
              <div className={styles.camera}>
                <div className={styles.icon} onClick={() => ref.current.click()}>
                  <input
                    id="img"
                    ref={ref}
                    name="uploaded_img"
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    hidden
                    onChange={handleChange}
                  />
                  <CameraIcon />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={styles.centered}>
          <UpdateProfil
            user={user}
            handlerUpdate={handlerUpdate}
            cancel={() => update(false)}
            isUpdate={isUpdate}
            update={update}
            resetPassword={resetPassword}
          />
        </div>
      </div>

      <ChangePassword
        open={openUpdatePassword}
        cancel={() => {
          setOpenUpdatePasseword(false);
          pwd(false);
        }}
        handlePasswordChange={handlePasswordChange}
      />
      <Dialog
        title="Confirmation"
        open={confirm}
        confirmButtonTitle="Confirm"
        handleClose={() => setConfirm(false)}
        handleConfirm={() => {
          setConfirm(false);
          if (isPwd) {
            changePassword();
          } else {
            updateUserHandler();
          }
          pwd(false);
        }}
      >
        {isPwd ? "Are sure you want update your password?" : "Are sure you want update your profile?"}
      </Dialog>
    </div>
  );
}
